<div id="FailedDoorModal" class="modal is-touch is-short failed-door-z-index-fix" [ngClass]="{'is-open': (isModalOpen | async)}">
  <div class="modal__content">
    <div id="instructionHeader" class="modal__header h2">
      Access Point Test Tool
    </div>
    <div class="modal__body pt0">
      <div class="row">
        <div id="instructionBody1" class="col-12 pb2 px2">
          Used for testing a selected Access Point(AC). You can Lock or Unlock an access point with this tool for testing only.
        </div>
      </div>
      <div class="row p2">
        <absg-spinner id="searchSpinner" [show]="showSearchSpinner$ | async"></absg-spinner>
        <div class="items col-12 border-top border-gray-87 pt2">
          <div class="row">
            @for (accessPoint of accessPoints; track trackItem($index, accessPoint)) {
              <div class="col-3 pr2 mb1">
                <div id="acButton-{{accessPoint.id}}" [ngClass]="selectedAccessPoint?.id === accessPoint?.id ? 'bg-true-blue-700 white' : 'bg-white'"
                  class="py2 border border-gray-87 border-radius center" (click)="selectAc(accessPoint)">
                  <div class="row">
                    <strong>{{accessPoint.name}}</strong>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="modal__footer">
      <div class="flex-auto">
        <button id="closeAccessPointToolBtn" class="btn btn--true-blue-inverse" (click)="close()">Close</button>
      </div>
      <div class="flex">
        <button class="btn btn--true-blue" [ngClass]="{'is-disabled': !selectedAccessPoint}" id="failAccessPointToolBtn"
          (click)="failAccessPoint()">Fail AC</button>
        <button class="btn btn--true-blue ml2" [ngClass]="{'is-disabled': !selectedAccessPoint}" id="unlockAccessPointToolBtn"
          (click)="unlockAccessPoint()">Unlock AC</button>
      </div>
    </div>
  </div>
</div>